/* global axios */
import ApiClient from './ApiClient';

class Inboxes extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getAssignableAgents(inboxId) {
    return axios.get(`${this.url}/${inboxId}/assignable_agents`);
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }
  fetch_ws_personal_status(payload) {
    return axios.post(`${this.url}/fetch_ws_personal_status`,payload);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  generateWaPersonalQR(payload) {
    return axios.post(`${this.url}/generate_ws_personal`,payload);
  }

  updateCallSetting(inboxId,payload) {
    return axios.post(`${this.url}/${inboxId}/update_call_settings`,payload);
  }

}

export default new Inboxes();
